export class ProgramContactInfo {
    public id: number;
    public name: string;
    public agencyName: string;
    public address: string;
    public cityId: number;
    public cityName: string;
    public agencyId: number;
    public zipCode: string;
    public phoneNumber: string;
    public website: string;
    public email: string;
    public contactName: string;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-contact-info.ts